import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { Header } from "./components/store/Header";
import { Footer } from "./components/store/Footer";
import { CartDrawer } from "./components/store/CartDrawer";
import { WelcomePopup } from "./components/store/WelcomePopup";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import TrackOrder from "./pages/TrackOrder";
import FlipBookCatalog from "./pages/FlipBook";
import B2B from "./pages/B2B";
import Admin from "./pages/Admin";
import Packaging from "./pages/Packaging";
import Certificazioni from "./pages/Certificazioni";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    const raf = (t) => {
      lenis.raf(t);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <CartProvider>
          <ScrollTop />
          <Header />
          <CartDrawer />
          <WelcomePopup />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/prodotti" element={<Products />} />
              <Route path="/prodotto/:slug" element={<ProductDetail />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/ordine" element={<TrackOrder />} />
              <Route path="/libro" element={<FlipBookCatalog />} />
              <Route path="/packaging" element={<Packaging />} />
              <Route path="/certificazioni" element={<Certificazioni />} />
              <Route path="/b2b" element={<B2B />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="bottom-left" richColors />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
